





















import Vue from 'vue'
import massApis from '@/mass/apis';

import Tpl from './Tpl.vue';
import { SubTpl, TplType } from '@/mass/models/SubTpl';
import TplMsgEdit from './TplMsgEdit.vue';

export default Vue.extend({
  components: {
    Tpl,
    TplMsgEdit,
  },
  data() {
    const counts: {[k: string]: number} = {}
    const tpls: SubTpl[] | null = null
    const currEdit: SubTpl | null = null
    return {
      counts,
      currEdit,
      tpls,
    }
  },
  computed: {

  },
  methods: {

    async loadTpls() {
      const tplsR = await massApis.getSubTpls({}).promise;
      this.tpls = tplsR.list
      this.loadCounts()
    },
    async loadCounts() {
      const onceIds = this.tpls.filter(t => t.type === TplType.Once).map(t => t.tplId)
      const counts1 = await massApis.getSubCounts({tplIds: onceIds, isOnce: true}).promise
      const repeatedIds = this.tpls.filter(t => t.type === TplType.Repeated).map(t => t.tplId)
      const counts2 = await massApis.getSubCounts({tplIds: repeatedIds, isOnce: false}).promise
      this.counts = {...counts1, ...counts2}
    },
  },
  mounted() {
    this.loadTpls()
  },
})
